import { render, staticRenderFns } from "./PayPal.vue?vue&type=template&id=fd0f923e&scoped=true&"
import script from "./PayPal.vue?vue&type=script&lang=js&"
export * from "./PayPal.vue?vue&type=script&lang=js&"
import style0 from "./PayPal.vue?vue&type=style&index=0&id=fd0f923e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd0f923e",
  null
  
)

export default component.exports